import { Component, effect, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Genus, Folder, Content, Site } from '@xanadu/model';
import { NodeComponent } from '@xanadu/core';

@Component({
    selector: 'app-content-node',
    templateUrl: './content-node.component.html',
    styleUrls: ['./content-node.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContentNodeComponent extends NodeComponent {
    protected get nodeType(): string | undefined {
        return 'content';
    }

    private iconRoot: string = 'account_tree';
    private iconSite: string = 'public';
    private iconGenus: string = 'insert_drive_file';
    private iconFolder: string = 'folder';
    private iconContent: string = 'description';

    constructor(
    ) {
        super();

        effect(() => {
            const model = this.model();

            if (model) {
                if (model.node instanceof Site) {
                    this.icon = this.iconSite;
                } else if (model.node instanceof Folder) {
                    this.icon = this.iconFolder;
                } else if (model.node instanceof Genus) {
                    if (model.node.parentId) {
                        this.icon = this.iconGenus;
                    } else {
                        this.icon = this.iconRoot;
                    }
                } else if (model.node instanceof Content) {
                    this.icon = this.iconContent;
                }
            }
        });
    }
}
